// React
import { useContext, useEffect, useState } from "react";
// Components
import { BaseTable, Loading, Pagination, TableHeaderSort, TableSorting } from "components";
import { FilterSection, RowSection } from "./components";

// Utils
import { useList } from "./utils";
import { DataContext } from "../utils/contexts";

export function RequestForm(): JSX.Element {
  // Hooks
  const {
    data,
    filter,
    isLoading,
    pagination,
    handleCheckbox,
    handlePage,
    handleSearch,
    reset,
  } = useList();
  const { setFill, setActiveColumn } = useContext(DataContext);

  const header: TableSorting[] = [
    { title: "ITEM CODE", value: "item_code", isActive: true },
    { title: "BARCODE", value: "barcode", isActive: true },
    { title: "BUILD", value: "build", isActive: true },
    { title: "DESCRIPTION", value: "description", isActive: true },
    { title: "UNIT", value: "unit", isActive: true },
    { title: "SOH", value: "soh", isActive: true },
    { title: "ON ORDER", value: "on_order", isActive: true },
    { title: "COMMITED", value: "commit", isActive: true },
    { title: "AVAILABLE", value: "available", isActive: true },
  ]

  const [tableActive, setTableActive] = useState<TableSorting[]>(header);

  useEffect(() => {
    setFill({
      buy: filter.buy,
      inv: filter.inventory,
      build: filter.isBuild
    })
    setActiveColumn && setActiveColumn(tableActive);
  }, [setFill, setActiveColumn, tableActive, filter.buy, filter.inventory, filter.isBuild]);

  return (
    <div className="my-3 flex flex-col gap-3">
      <FilterSection
        filter={filter}
        handleCheckbox={handleCheckbox}
        handlePage={handlePage}
        handleSearch={handleSearch}
        reset={reset}
        tableActive={tableActive}
        setTableActive={setTableActive}
      />

      <div className="overflow-auto max-h-[calc(100vh-600px)]">
        <BaseTable className="border-collapse">
          <thead className="bg-white sticky top-0 z-[0] !bg-black !text-white">
            <tr>
              <th>NO</th>

              <TableHeaderSort
                title={tableActive}
              />
              
              <th>REQUEST</th>
            </tr>
          </thead>

          <tbody>
            {isLoading || !data.length ? (
              <tr>
                <td colSpan={11}>
                  <Loading loading={isLoading} errorText="No data available" />
                </td>
              </tr>
            ) : (
              data.map((item, key) => (
                <RowSection
                  key={key}
                  currentPage={filter.page}
                  index={key}
                  item={item}
                  size={pagination.size}
                  tableActive={tableActive}
                />
              ))
            )}
          </tbody>
        </BaseTable>

        <Pagination
          limit={0}
          currentPage={filter.page}
          totalPage={pagination.pages}
          total={pagination.total}
          size={pagination.size}
          onPageChange={handlePage}
        />
      </div>
    </div>
  );
}


